import { NetworkData } from '../locality/networkDataStorage';

const determineIpType = (networkData?: NetworkData) => {
  if (
    networkData &&
    networkData.internalIps &&
    networkData.internalIps.length > 0
  ) {
    return 'ip';
  } else if (networkData && networkData.internalMdns) {
    return 'mdns';
  }
  return 'unknown';
};

export default determineIpType;
